export const CONTACT_NUMBER = '5533999558053' as const
